<template>
  <div class="pill-bar d-flex flex-wrap">
    <v-chip
      v-for="pill in pills"
      :key="pill.key"
      small
      :style="pillStyle(pill)"
      class="font-weight-medium mr-2 mb-2"
      @click="clickable && $emit('select', pill.key)"
    >
      <span class="pill-dot mr-2" :style="{ backgroundColor: pill.color }" />
      <span class="font-weight-bold mr-1">{{ pill.count }}</span>
      {{ pill.label }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "SummaryPillBar",
  props: {
    pills: {
      type: Array,
      required: true,
    },
    activeKey: {
      type: [String, Number],
      default: null,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    hexToRgba(hex, alpha) {
      const clean = (hex || "#9e9e9e").replace("#", "");
      const bigint = parseInt(clean, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    pillStyle(pill) {
      const isSelected = this.activeKey === pill.key;
      const isFiltering = this.clickable && this.activeKey != null;
      return {
        backgroundColor: this.hexToRgba(pill.color, isSelected ? 0.18 : 0.1),
        color: pill.color,
        border: `1px solid ${isSelected ? pill.color : "transparent"}`,
        opacity: isFiltering && !isSelected ? 0.55 : 1,
        cursor: this.clickable ? "pointer" : "default",
        transition: "opacity 0.15s ease",
      };
    },
  },
};
</script>

<style scoped>
.pill-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
</style>
